import { useMutation } from '@tanstack/react-query';
import { postNewTimesheetVersion } from '../Services/ProcessedTimesheetService';

const usePostNewTimesheetVersion = (options = {}) => useMutation(postNewTimesheetVersion, options);

export default usePostNewTimesheetVersion;
